<template>
    <div id="carouselExampleControls" class="relative" data-te-carousel-init data-te-ride="carousel">
        <!--Carousel items-->
        <div class="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
            <!--First item-->
            <div class="relative float-left -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none" data-te-carousel-item data-te-carousel-active>
                <img src="@/assets/images/business/bg05.jpg" class="block w-full" alt="Wild Landscape" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [require("@/assets/images/business/bg01.png"), require("@/assets/images/business/bg02.png"), require("@/assets/images/business/bg03.jpg")],
            currentIndex: 0,
        };
    },
    computed: {
        bgImage() {
            return this.images[this.currentIndex];
        },
    },
    mounted() {
        setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
        }, 5000);
    },
};
</script>

<style scoped>
.gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 60%);
}
</style>
